import type { NgDocCategory } from '@ng-doc/core';

const GettingStartedCategory: NgDocCategory = {
  title: 'Getting Started',
  order: 1
};

export default GettingStartedCategory;
